import React, { Component } from 'react';
import L from 'leaflet';
import { Map, Marker, TileLayer,Popup } from 'react-leaflet';
import { connect } from 'react-redux';

import markerIcon from '../../../images/leaflet/marker.png';
import MapPopupCard from '../../Card/MapPopupCard';


const locMarker = L.icon({
    iconUrl: markerIcon,
    iconSize: [29, 40],
    iconAnchor: [10, 24],
    popupAnchor: [0, 0],
});

class ActivityMap extends Component
{
    state = {
        markers: [],
        bounds: [],
        orgWithMultipleEvents: [],
    }

    componentDidMount() {
        this.processMarkers();
    }

    processMarkers = () => {
        let bounds = {};
        const newState = { markers: [] };

        const { data } = this.props.results;
        const orgWithMultipleEvents = [];

        let orgIds = [];

        if(this.props.results.data) {
            Object.keys(this.props.results.data).map(item => {
                const { organisation } = data[item];

                if(organisation) {
                    if (orgIds.indexOf(organisation.id) !== -1) {
                        orgWithMultipleEvents.push(organisation.id);
                    }
                    orgIds.push(organisation.id);

                    if(organisation.latitude && organisation.longitude) {
                        const ll = [parseFloat(organisation.latitude), parseFloat(organisation.longitude)];
                        newState.markers.push(data[item]);
                        bounds[ll.toString()] = ll;
                    }
                }
            });
        }
        if(bounds.length === 1) {
            // bounds.push(bounds[0]);
        }

        if(bounds.length > 2) {
            newState.bounds = Object.values(bounds);
        };
        this.setState(newState);

        if (orgWithMultipleEvents.length > 0) {
            this.setState({
                orgWithMultipleEvents: orgWithMultipleEvents
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // only update chart if the data has changed
        if (prevProps.results !== this.props.results) {
            this.processMarkers();
        }
    }

    render() {
        const center = [50.8156352,-2.3129144];
        console.log(this.state.bounds)
        return (
            <div className="aspect-ratio-image map-container">
                <div className="map-wrapper">
                    <Map
                        className='results-map'
                        center={center}
                        zoom={10}
                        scrollWheelZoom={false}
                        bounds={this.state.bounds.length ? this.state.bounds : null}
                    >
                        <TileLayer
                            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        {this.state.markers && this.state.markers.map(marker => {
                            if(!marker.organisation.latitude || !marker.organisation.longitude) return null;
                            return (
                                <Marker
                                    position={[parseFloat(marker.organisation.latitude), parseFloat(marker.organisation.longitude)]}
                                    icon={locMarker}
                                    key={marker.id}
                                >
                                    <Popup maxWidth="354">
                                        <MapPopupCard marker={marker} orgWithMultipleEvents={this.state.orgWithMultipleEvents}/>
                                    </Popup>
                                </Marker>
                            );
                            }
                        )}
                    </Map>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    results: state.searchActivities
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityMap);

